// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._3wrK7MZDx{line-height:20px;width:100%}._3wrK7MZDx>*{max-width:100%}._17Za93kzx{}._17Za93kzx>:first-child{flex-shrink:1;overflow:hidden;margin-right:8px}._17Za93kzx>:last-child{flex-shrink:0}._2Si2FLNIx{min-height:64px}[data-panel-position=secondary] ._2Si2FLNIx{min-height:0}._2Si2FLNIx ._5v9O4D3Cx,._2Si2FLNIx ._4YbJtYN2x{margin:0}._2Si2FLNIx ._5v9O4D3Cx{line-height:20px}._2Si2FLNIx ._4YbJtYN2x{line-height:16px}._1Z7YhqBPx{flex:0 1 300px}._2gWSMtfPx{}._2gWSMtfPx ._5v9O4D3Cx{margin-bottom:0}._2gWSMtfPx ._4YbJtYN2x{margin-top:0}._5v9O4D3Cx{color:var(--primary-text);flex:0 0 auto}._4Wi4OEf2x{display:inline-block;padding:0px 8px;margin-left:4px;color:var(--secondary-text);text-transform:uppercase;font-size:10px;line-height:16px;background:var(--alpha-8);border-radius:2px;vertical-align:text-bottom}._4YbJtYN2x{color:var(--secondary-text);flex:1;margin-left:10px}._1GpJjKBVx{line-height:0;margin-right:8px}._35g5txOZx{margin-top:-8px;margin-bottom:-8px}._4IpCQiInx{margin-top:-16px;margin-bottom:-16px}._7anwgxBxx{margin-top:-24px;margin-bottom:-24px}._2NjNGwJLx{margin-top:-32px;margin-bottom:-32px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_3wrK7MZDx",
	"stretch": "_17Za93kzx _3wrK7MZDx",
	"large-container": "_2Si2FLNIx _3wrK7MZDx",
	"largeContainer": "_2Si2FLNIx _3wrK7MZDx",
	"title": "_5v9O4D3Cx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-m"] + "",
	"subtitle": "_4YbJtYN2x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-s"] + "",
	"skeleton": "_1Z7YhqBPx _3wrK7MZDx",
	"large-skeleton": "_2gWSMtfPx _1Z7YhqBPx _3wrK7MZDx _2Si2FLNIx _3wrK7MZDx",
	"largeSkeleton": "_2gWSMtfPx _1Z7YhqBPx _3wrK7MZDx _2Si2FLNIx _3wrK7MZDx",
	"badge": "_4Wi4OEf2x",
	"icon": "_1GpJjKBVx",
	"icon-small": "_35g5txOZx _1GpJjKBVx",
	"iconSmall": "_35g5txOZx _1GpJjKBVx",
	"icon-medium": "_4IpCQiInx _1GpJjKBVx",
	"iconMedium": "_4IpCQiInx _1GpJjKBVx",
	"icon-large": "_7anwgxBxx _1GpJjKBVx",
	"iconLarge": "_7anwgxBxx _1GpJjKBVx",
	"icon-xlarge": "_2NjNGwJLx _1GpJjKBVx",
	"iconXlarge": "_2NjNGwJLx _1GpJjKBVx"
};
module.exports = exports;
